import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { EMPTY, finalize, first } from 'rxjs';
import { VehicleResponse, VehiclesClient } from '../../shared';
import { LoadingDefaults } from '../../shared/models/loading-defaults.model';
import { RplLoadingService } from '../../shared/services/rpl-loading.service';

export const vehicleResolver: ResolveFn<VehicleResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const vehiclesClient = inject(VehiclesClient);
  const loadingService = inject(RplLoadingService);
  const router = inject(Router);

  const vehicleId = Number(route.paramMap.get('vehicleId'));

  if (Number.isNaN(vehicleId)) {
    void router.navigate(['vehicle']);
    return EMPTY;
  }

  let loadingId: string | undefined;
  const timeout = setTimeout(() => {
    loadingId = loadingService.start();
  }, LoadingDefaults.StartIndicatorTimeout);

  return vehiclesClient.getVehicleById(vehicleId).pipe(
    first(),
    finalize(() => {
      clearTimeout(timeout);
      loadingService.end(loadingId);
    }),
  );
};
